import { Steps } from 'antd';

import MainInformation from '@Components/ComposedComponents/MainInformation';
import PublishingDates from '@Components/ComposedComponents/PublishingDates';
import SEOInformation from '@Components/ComposedComponents/SEOInformation';
import CopyrightInformation from '@Components/ComposedComponents/CopyrightInformation';
import LinksAndAttachments from '@Components/ComposedComponents/LinksAndAttachments';
import VideoUpload from '@Components/ComposedComponents/VideoUpload';
import StepButtons from '../ComposedComponents/StepButtons';

const steps = [
	{
		title: 'Metadata Information',
		key: 'METADATA_INFORMATION',
	},
	{
		title: 'Files Uploading',
		key: 'FILES_UPLOADING',
	},
];

export default function VideoForm (props) {
	const {step, setStep} = props;

	return (
		<>
			<Steps type="navigation" current={step} items={steps} style={{ marginBottom: 50 }}/>
			{step === 0 && (
				<>
					<MainInformation {...props}/>
					<br/><br/>
					<SEOInformation {...props}/>
					<br/><br/>
					<PublishingDates {...props}/>
					<br/><br/>
					<CopyrightInformation {...props}/>
					<br/><br/>
					<LinksAndAttachments {...props}/>
					<br/><br/>
				</>
			)}
			{step === 1 && (
				<>
					<VideoUpload {...props} />
					<br/><br/><br/>
				</>
			)}
			<StepButtons totalSteps={steps.length} currentStep={step} setStep={setStep} {...props}/>
		</>
	);
}
